import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingModule = () => {
  return (
    <div className="loading-card">
      <div className="loading-icon">
        <LoadingOutlined spin />
      </div>
      <div className="loading-text">
        Загрузка данных,<br />пожалуйста подождите
      </div>
    </div>
  );
};

export default LoadingModule;